module.exports = __webpack_public_path__ + "img/Speaker=Carl Barrelet.f06bf664.png";